<template>
    <div class="right-side-bar-main-sec">
        <div class="section-listing-page">
            <section class="bet-details-sec">
                <div class="bet-details-header">
                    <div class="row">
                        <div class="col-12 col-md-6 d-flex justify-content-between align-items-center">
                            <div v-if="type" class="list-sport-title">
                                <img loading="lazy" :src="getSportImage(sport_id)" alt="tennis icon" />
                                <span>&nbsp;&nbsp;{{ getTitle() ? (getTitle() == 'Soccer' ? $t('football','Football') : $t(getTitle()?.toLowerCase()?.replaceAll(' ','-'),getTitle()?.replaceAll('-','') ) ) : (type == 'soccer' ? $t('football','Football') : $t(type?.toLowerCase()?.replaceAll(' ','-'),type?.replaceAll('-',' ') ) ) }}</span>
                            </div>
                            <ul class="live_virtual">
                                <li><input type="checkbox" value="Order one" class="filter-checkbox" @change="toggleFilter('live')"><label>{{$t('live','LIVE')}}</label></li>
                                <li><input type="checkbox" value="Order Two" class="filter-checkbox" @change="toggleFilter('virtual')"><label>{{$t('virtual','VIRTUAL')}}</label></li>
                            </ul>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="add-even-sec" v-if="filteredMatchList && filteredMatchList.length > 0">
                                <div class="stack-1">
                                    <span>1</span>
                                </div>
                                <div class="stack-1">
                                    <span>X</span>
                                </div>
                                <div class="stack-1">
                                    <span>2</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="filteredMatchList && filteredMatchList?.length">
                    <SportItem :sportsData="filteredMatchList"/>
                </div>
                <div class="norecords" v-else-if="!$store.getters.globalLoader && filteredMatchList?.length == 0">
                    {{$t('no-real-records', 'No Real-Time Records Found')}}
                </div>
            </section>
            <Banner />
        </div>
    </div>

</template>

<script>

import { defineAsyncComponent } from 'vue';
import { checkForLockedMatches } from '@/shared/services/eventLocks.js';

export default {
    name: "Sports",
    components: {
        Banner: defineAsyncComponent(() =>
            import('@/shared/components/banner/Banner.vue')
        ),
        SportItem: defineAsyncComponent(() =>
            import('../components/SportItem.vue')
        )
    },
    data() {
        return {
            type: null,
            sport_id:this.$route.params.id,
            matches_list:[],
            favouriteEvents: this.$store.getters.favouriteGames,
            leagues: {},
            eventManage: null,
            selectedFilters:[],
        }
    },
    computed:{
        filteredMatchList() {
            if (this.selectedFilters.includes('live') && this.selectedFilters.includes('virtual')) {
                return this.matches_list || [];
            }

            if (this.selectedFilters.includes('live')) {
                const temporaryData = (this.matches_list || []).filter(match => match.is_exclusive === 0);
                return temporaryData;
            }

            if (this.selectedFilters.includes('virtual')) {
                const temporaryData = (this.matches_list || []).filter(match => match.is_exclusive === 1)
                return temporaryData;
            }

            return this.matches_list || [];
        },
    },
    created() {
		this.eventManage = this.$store?.getters?.eventManage;
    },
    mounted() {
        this.type = this.$route?.params?.type;
        this.getMatchesList()
    },
    methods: {
        getMatchesList() {
            this.$store.dispatch('setGlobalLoader', true);
            this.$apiCall('get', 'MATCHES_BY_SPORT_ID', null, 'sports', { sport_id: this.sport_id }).then(response => {         
                if (response) {
                    this.$store.dispatch('setGlobalLoader', false);
                    if (response.status == 200) {
                        this.matches_list = []
                        this.matches_list = response.data.data
                        this.matches_list.sort().reverse()
                        let lockedMatchIds = [];
                        let lockedLeagueIds = [];
                        if(this.$auth?.status && this.eventManage) {
                            lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                            lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                            lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                            lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                        }

                        for (var i = this.matches_list.length - 1; i >= 0; i--) {
                            if(checkForLockedMatches(this.matches_list[i].matchId, this.matches_list[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                                if (this.favouriteEvents?.length && this.favouriteEvents?.includes(parseInt(this.matches_list[i].event_id))) {
                                    this.matches_list[i]['favourite'] = true
                                } else {
                                    this.matches_list[i]['favourite'] = false
                                }
                            } else {
                                this.matches_list.splice(i, 1)
                            }
                        }

                        this.matches_list?.forEach(item => {
                            const leagueName = item.league_name;
                            if (!this.leagues[leagueName]) {
                                this.leagues[leagueName] = [];
                            }
                            this.leagues[leagueName].push(item);
                        });
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error);
                }
            });
        },
        getSportImage(sportId) {
            const imageMap = {
                4: require("@/assets/images/sports-cricket.png"),
                1: require("@/assets/images/sports-soccer.png"),
                2: require("@/assets/images/sports-tennis.png"),
                1477: require("@/assets/images/sports-rugby-league.png"),
                6: require("@/assets/images/sports-boxing.png"),
                5: require("@/assets/images/sports-rugby-union.png"),
                3: require("@/assets/images/sports-golf.png"),
                27454571: require("@/assets/images/sports-esports.png"),
                2152880: require("@/assets/images/sports-gaelic-football.png"),
                998917: require("@/assets/images/sports-volleyball.png"),
                7524: require("@/assets/images/sports-ice-hockey.png"),
                7522: require("@/assets/images/sports-basketball.png"),
                7511: require("@/assets/images/sports-baseball.png"),
                6423: require("@/assets/images/sports-american-football.png"),
                6422: require("@/assets/images/sports-snooker.png"),
                11: require("@/assets/images/sports-cycling.png"),
                8: require("@/assets/images/sports-motor-sport.png"),
                2378961: require("@/assets/images/sports-politics.png"),
                468328: require("@/assets/images/sports-handball.png"),
                61420: require("@/assets/images/sports-australian-rules.png"),
                3503: require("@/assets/images/sports-darts.png"),
                10: require("@/assets/images/sports-special-bets.png"),
                26420387: require("@/assets/images/sports-mixed-martial-arts.png"),
                4339: require("@/assets/images/sports-greyhound-racing.png"),
                7: require("@/assets/images/sports-horse-racing.png"),
                4343: require("@/assets/images/fifa-cup-winner.png"),
                4344: require("@/assets/images/winner-cup.png"),
                4345: require("@/assets/images/election.png"),
                27454572: require("@/assets/images/kabaddi.png"),
                27454574: require("@/assets/images/table-tennis.png"),
            };
            return imageMap[sportId] || require("@/assets/images/sports-no.png");
        },
        getTitle() {
            switch (this.type) {
                case 'cricket':
                    return 'Cricket';
                case 'soccer':
                    return 'Football';
                case 'tennis':
                    return 'Tennis';
                case 'KABADDI':
                    return 'Kabaddi';
                case 'POLITICS':
                    return 'Politics';
                case 'SPORTS_BOOK':
                    return 'Sports Book';
                case 'binary':
                    return 'Binary';
                default:
                    break;
            }
        },
        
        toggleFilter(filterKey) {
            if (this.selectedFilters.includes(filterKey)) {
                this.selectedFilters = this.selectedFilters.filter(f => f !== filterKey);
            } else {
                this.selectedFilters.push(filterKey);
            }
        }
    }
};
</script>